// extracted by mini-css-extract-plugin
export default {"mainContentView":"AppContentView_mainContentView__mx2gM"};